import $api from "../http";
import {AxiosResponse} from "axios";
import {ICustomer} from "../models/ICustomer";

export default class CustomersService{
    static async fetchCustomers():Promise<AxiosResponse<ICustomer[]>>{
        return $api.get('/customers/getCustomers');
    }
}